import { PetPackageContent as PackageContent } from './pets/PetPackageContent.js';
import { displayLabel as label, runLabels as states } from './pets/displayLabels.js';
/** Read-only review presentation; callers own their surrounding UI-kit styles.
 * Explicit public types keep internal source paths out of the shipped declaration. */
export const PetPackageContent = PackageContent;
export const runLabels = states;
export const displayLabel = label;
//# sourceMappingURL=petsReview.js.map